import { getUrlParameter, makeKTBlock, makeSwal } from '../../general/functions';
import { BASE_URL } from '../../general/variables';
import { formatPaymentData } from './function';

const studentPromotions = $('#promotionTable').KTDatatable({
  data: {
    type: 'remote',
    source: {
      read: {
        url: BASE_URL + 'C_Event/getStudentwithPromotion',
        params: {
          id: $('#formInfoDetails [name="eventID"]').val() ?? 'EMPTY',
        },
        map: function (raw) {
          $('#totalPIC').html('(' + raw.length + ')');

          let dataSet = raw;

          if (typeof raw.data !== 'undefined') {
            dataSet = raw.data;
          }

          return dataSet;
        },
      },
    },
    pageSize: 10,
    serverPaging: false,
    serverFiltering: false,
    serverSorting: false,
  },
  layout: {
    scroll: false,
    footer: false,
  },
  sortable: true,
  pagination: true,
  columns: [
    {
      field: 'STUDENT_NAME',
      title: 'Student Name',
      type: 'text',
      template: function (row) {
        return `<span class="font-weight-bolder">
                        <a href="${BASE_URL + 'detail_student?id=' + row.STUDENT_ID}" target="_blank">${row.NAME}</a> 
                    <span class="text-muted font-weight-bold"> via ${formatPaymentData('PAYMENT_METHOD', row.PAYMENT_METHOD)}</span></span>`;
      },
    },
    {
      field: 'COUNSELLOR_ID',
      title: 'Counsellor',
      template: function (row) {
        if (row.COUNSELLOR_NAME === null) {
          return `<span class="font-weight-bolder text-warning">Unhandled</span>`;
        } else {
          return `<span class="font-weight-bolder">
                            ${row.COUNSELLOR_NAME} - <span class="text-muted font-weight-bold">(${row.COUNSELLOR_BRANCH})</span>
                        </span>`;
        }
      },
    },
    {
      field: 'UNI_NAME',
      title: 'University',
      template: function (row) {
        return `<span class="font-weight-bolder">
                        ${formatPaymentData('PAYMENT_TYPE', row.PAYMENT_TYPE)} for ${row.UNI_NAME}<br/>Intake: ${row.INTAKE}<br/>
                        <span class="text-muted font-weight-bold">IDR ${parseInt(row.PAYMENT_AMOUNT).toLocaleString('id-ID')}</span>
                    </span>`;
      },
    },
    {
      field: 'DEPOSIT_PATH',
      title: 'File',
      width: 120,
      template: function (row) {
        return `<a href="${row.DEPOSIT_PATH}" target="_blank" class="font-weight-bold">
                        ${row.TRANSACTION_ID}
                    </a>`;
      },
    },
    {
      field: 'NOTES',
      title: 'Notes',
      template: function (row) {
        return `<span class="font-weight-bold">
                        ${row.NOTES} <br/><br/>
                        Promotion Item: ${formatPaymentData('PROMOTION_TYPE', row.PROMOTION_TYPE)}
                    </span>`;
      },
    },
    {
      field: '',
      title: 'Action',
      template: function (row) {
        if (row.DEPOSIT_STATUS === 'CREATED') {
          return `<button type="button" class="btn btn-sm btn-light-primary btn-deposit-action mr-3" data-id="${row.REC_ID}" data-event="${row.EVENT_ID}" data-action="FINALIZE" title="Finalize Deposit">
                            <span class="svg-icon svg-icon-primary svg-icon-2x mr-0">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                    <title>Finalize Deposit</title>
                                    <desc>Created with Sketch.</desc>
                                    <defs/>
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <polygon points="0 0 24 0 24 24 0 24"/>
                                        <path d="M9.26193932,16.6476484 C8.90425297,17.0684559 8.27315905,17.1196257 7.85235158,16.7619393 C7.43154411,16.404253 7.38037434,15.773159 7.73806068,15.3523516 L16.2380607,5.35235158 C16.6013618,4.92493855 17.2451015,4.87991302 17.6643638,5.25259068 L22.1643638,9.25259068 C22.5771466,9.6195087 22.6143273,10.2515811 22.2474093,10.6643638 C21.8804913,11.0771466 21.2484189,11.1143273 20.8356362,10.7474093 L17.0997854,7.42665306 L9.26193932,16.6476484 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" transform="translate(14.999995, 11.000002) rotate(-180.000000) translate(-14.999995, -11.000002) "/>
                                        <path d="M4.26193932,17.6476484 C3.90425297,18.0684559 3.27315905,18.1196257 2.85235158,17.7619393 C2.43154411,17.404253 2.38037434,16.773159 2.73806068,16.3523516 L11.2380607,6.35235158 C11.6013618,5.92493855 12.2451015,5.87991302 12.6643638,6.25259068 L17.1643638,10.2525907 C17.5771466,10.6195087 17.6143273,11.2515811 17.2474093,11.6643638 C16.8804913,12.0771466 16.2484189,12.1143273 15.8356362,11.7474093 L12.0997854,8.42665306 L4.26193932,17.6476484 Z" fill="#000000" fill-rule="nonzero" transform="translate(9.999995, 12.000002) rotate(-180.000000) translate(-9.999995, -12.000002) "/>
                                    </g>
                                </svg>
                            </span>
                        </button>
                        <button type="button" class="btn btn-sm btn-light-danger btn-deposit-action" data-id="${row.REC_ID}" data-action="REJECT" title="Reject Deposit">
                            <span class="svg-icon svg-icon-danger svg-icon-2x mr-0">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                    <title>Reject Deposit</title>
                                    <desc>Created with Sketch.</desc>
                                    <defs/>
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect x="0" y="0" width="24" height="24"/>
                                        <path d="M6,8 L18,8 L17.106535,19.6150447 C17.04642,20.3965405 16.3947578,21 15.6109533,21 L8.38904671,21 C7.60524225,21 6.95358004,20.3965405 6.89346498,19.6150447 L6,8 Z M8,10 L8.45438229,14.0894406 L15.5517885,14.0339036 L16,10 L8,10 Z" fill="#000000" fill-rule="nonzero"/>
                                        <path d="M14,4.5 L14,3.5 C14,3.22385763 13.7761424,3 13.5,3 L10.5,3 C10.2238576,3 10,3.22385763 10,3.5 L10,4.5 L5.5,4.5 C5.22385763,4.5 5,4.72385763 5,5 L5,5.5 C5,5.77614237 5.22385763,6 5.5,6 L18.5,6 C18.7761424,6 19,5.77614237 19,5.5 L19,5 C19,4.72385763 18.7761424,4.5 18.5,4.5 L14,4.5 Z" fill="#000000" opacity="0.3"/>
                                    </g>
                                </svg>
                            </span>
                        </button>`;
        } else {
          return '';
        }
      },
    },
  ],
});

const formAddDeposit = document.getElementById('formAddDeposit');
const postDepositValidation = formAddDeposit
  ? FormValidation.formValidation(formAddDeposit, {
      fields: {
        depositAddStudent: {
          validators: {
            notEmpty: {
              message: 'Please select student',
            },
          },
        },
        depositAddIntake: {
          validators: {
            notEmpty: {
              message: 'Please intake date',
            },
          },
        },
        depositAddUniversity: {
          validators: {
            notEmpty: {
              message: 'Please select university of choice',
            },
          },
        },
        depositAddCounsellor: {
          validators: {
            notEmpty: {
              message: 'Please select counsellor',
            },
          },
        },
        depositPaymentType: {
          validators: {
            notEmpty: {
              message: 'Please select payment type',
            },
          },
        },
        depositPaymentDesc: {
          validators: {
            notEmpty: {
              message: 'Please select payment purpose',
            },
          },
        },
        depositPaymentAmount: {
          validators: {
            notEmpty: {
              message: 'Please select payment amount',
            },
          },
        },
        depositPaymentMethod: {
          validators: {
            notEmpty: {
              message: 'Please select payment method',
            },
          },
        },
        depositPaymentPromotion: {
          validators: {
            notEmpty: {
              message: 'Please select promotion details',
            },
          },
        },
        depositOthPromo: {
          validators: {
            notEmpty: {
              message: 'Please select others promotion',
            },
          },
        },
        promotionDetails: {
          validators: {
            notEmpty: {
              message: 'Please select promotion details',
            },
          },
        },
      },
      plugins: {
        trigger: new FormValidation.plugins.Trigger(),
        excluded: new FormValidation.plugins.Excluded(),
        bootstrap: new FormValidation.plugins.Bootstrap(),
      },
    })
  : null;

const generateDepositObject = (data) => {
  const curData = {
    EVENT: data.EVENT,
    USER: data.USER,
    detail: {
      NAME: data.NAME,
      COUNSELLOR: data.COUNSELLOR,
      UNIVERSITY: data.UNIVERSITY,
      NOTES: data.NOTES,
      PROMOTION_TYPE: null,
      PROMOTION_DESC: null,
      INTAKE: data.INTAKE,
      AMOUNT: null,
      PAYMENT_TYPE: null,
      PAYMENT_DESC: null,
      PAYMENT_METHOD: data.PAYMENT_METHOD,
    },
  };

  let curAmount = 0;

  if (data.AMOUNT !== null) {
    curAmount = data.AMOUNT.replace(/[^0-9]/g, '');
  }

  curData.detail.AMOUNT = curAmount;

  curData.detail.PROMOTION_TYPE = data.PROMOTION_TYPE;
  curData.detail.PAYMENT_TYPE = data.PAYMENT_TYPE;

  if (data.PROMOTION_TYPE.includes('OTHERS')) {
    curData.detail.PROMOTION_DESC = data.PROMOTION_DESC;
  }

  if (data.PAYMENT_TYPE === 'OTHERS') {
    curData.detail.PAYMENT_DESC = data.PAYMENT_DESC;
  }

  return curData;
};

const studentTableListener = () => {
  /** Button Listener */
  $(document).on('click', '.btn-deposit-action', function () {
    const curBtn = $(this);

    KTApp.block('#promotionTable', {
      opacity: 0.1,
      state: 'primary',
      message: 'Please wait...',
    });

    /** Finalize dan kirim ke G_STUDENT_DEPOSIT */
    if (curBtn.attr('data-action') === 'FINALIZE') {
      $.post(BASE_URL + 'C_Event/updateDepositStatus', {
        id: curBtn.attr('data-id'),
        event: curBtn.attr('data-event'),
        action: 'FINALIZE',
      })
        .fail((err) => {
          console.log(err);

          Swal.fire({
            html: 'Cannot complete process! Please try again later',
            icon: 'warning',
            confirmButtonText: 'Close',
            showCancelButton: false,
          });

          KTApp.unblock('#promotionTable');
        })
        .done((posRes) => {
          if (posRes.code === 200) {
            Swal.fire({
              html: 'Deposit finalized and approved!',
              icon: 'success',
              confirmButtonText: 'Close',
              showCancelButton: false,
            });

            studentPromotions.reload();
          } else {
            if (posRes.code === 205) {
              Swal.fire({
                html: 'Student not assigned to counsellor! Please select another data',
                icon: 'warning',
                confirmButtonText: 'Close',
                showCancelButton: false,
              });
            } else {
              Swal.fire({
                html: 'Cannot complete process! Please try again later',
                icon: 'warning',
                confirmButtonText: 'Close',
                showCancelButton: false,
              });
            }

            KTApp.unblock('#promotionTable');
          }
        });
    } else if (curBtn.attr('data-action') === 'REJECT') {
      /** Reject proses transaksi */
      Swal.fire({
        html: 'Are you sure? This process cannot be <strong>reversed</strong>!',
        icon: 'question',
        confirmButtonText: 'Delete',
        showCancelButton: true,
        cancelButtonText: 'Close',
      }).then((btnRes) => {
        if (btnRes.isConfirmed) {
          $.post(BASE_URL + 'C_Event/updateDepositStatus', {
            id: curBtn.attr('data-id'),
            action: 'REJECT',
          })
            .fail((err) => {
              console.log(err);

              Swal.fire({
                html: 'Cannot complete process! Please try again later',
                icon: 'warning',
                confirmButtonText: 'Close',
                showCancelButton: false,
              });

              KTApp.unblock('#promotionTable');
            })
            .done((posRes) => {
              if (posRes.code === 200) {
                Swal.fire({
                  html: 'Deposit removed!',
                  icon: 'success',
                  confirmButtonText: 'Close',
                  showCancelButton: false,
                });

                studentPromotions.reload();
              } else {
                Swal.fire({
                  html: 'Cannot complete process! Please try again later',
                  icon: 'warning',
                  confirmButtonText: 'Close',
                  showCancelButton: false,
                });

                KTApp.unblock('#promotionTable');
              }
            });
        } else {
          KTApp.unblock('#promotionTable');
        }
      });
    }
  });

  $('#formAddPromotion').on('submit', function (e) {
    e.preventDefault();

    makeKTBlock('#modalAddPromotion .modal-dialog');
    let action = $(this).attr('action'),
      data = $(this).serialize();

    $.ajax({
      url: action,
      method: 'POST',
      dataType: 'JSON',
      data: data,
      success: function (resp) {
        makeKTBlock('#modalAddPromotion .modal-dialog', 'hide');
        const { header, message, status } = resp;
        makeSwal(header, message, status, 'action', '385px', 'reload-tab#promotion');

        $('#modalAddPromotion').modal('hide');
      },
      error: function (data) {
        makeKTBlock('#modalAddPromotion .modal-dialog', 'hide');
        makeSwal('Error!', 'Error - Contact IT Division', 'error');
        console.log(data);
      },
    });
  });

  $('#formEditPromotion').on('submit', function (e) {
    e.preventDefault();

    makeKTBlock('#modalEditPromotion .modal-dialog');
    let action = $(this).attr('action'),
      data = $(this).serialize();

    $.ajax({
      url: action,
      method: 'POST',
      dataType: 'JSON',
      data: data,
      success: function (resp) {
        makeKTBlock('#modalEditPromotion .modal-dialog', 'hide');
        const { header, message, status } = resp;
        makeSwal(header, message, status, 'action', '385px', 'reload-tab#promotion');

        $('#modalEditPromotion').modal('hide');
        studentPromotions.reload();
      },
      error: function (data) {
        makeKTBlock('#modalEditPromotion .modal-dialog', 'hide');
        makeSwal('Error!', 'Error - Contact IT Division', 'error');
        console.log(data);
      },
    });
  });

  /** Table Listener */
  studentPromotions.on('datatable-on-ajax-fail', function () {
    KTApp.unblock('body');

    Swal.fire({
      html: 'Cannot load Deposit Table! Please try again later',
      icon: 'error',
      confirmButtonText: 'Close',
      showCancelButton: false,
    });
  });

  studentPromotions.on('datatable-on-ajax-done', function () {
    KTApp.unblock('body');
  });

  $('#modalEditPromotion').on('shown.bs.modal', function () {
    makeKTBlock('#modalEditPromotion .modal-dialog');
    $.post(BASE_URL + 'Expo_Packages/getPromoDetails', { id: getUrlParameter('id') }, function (resp) {
      if (resp.code == 200) {
        $('#promoNameEdit').val(resp.data.NAME);
        $('#promoDateEdit').val(resp.data.FROM_DATE + '-' + resp.data.TO_DATE);
        $('#promoDetailEdit').val(resp.data.DESCRIPTION);
        $('#promoDateEdit').daterangepicker(
          {
            buttonClasses: ' btn',
            applyClass: 'btn-primary',
            cancelClass: 'btn-secondary',
            timePicker: true,
            timePickerIncrement: 30,
            locale: { format: 'YYYY/MM/DD' },
          },
          function (start, end, label) {
            $('#promoDateEdit .form-control').val(start.format('YYYY/MM/DD') + ' / ' + end.format('YYYY/MM/DD'));
          }
        );
        makeKTBlock('#modalEditPromotion .modal-dialog', 'hide');
      } else {
        Swal.fire({
          title: 'Invalid Action',
          html: 'Cannot get promotion details, please try again',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Delete',
          cancelButtonText: 'Close',
        });
        makeKTBlock('#modalEditPromotion .modal-dialog', 'hide');
      }
    });
  });
};

const formListener = () => {
  $('#formAddDeposit [name="depositPaymentType"]').on('change', function () {
    const curVal = $(this).val();

    if (curVal === 'OTHERS') {
      $('#formAddDeposit #otherPaymentDescription').show();
    } else {
      $('#formAddDeposit #otherPaymentDescription').hide();
    }
  });

  $('#formAddDeposit [name="depositPaymentPromotion"]').on('change', function () {
    const curVal = $(this).val();

    if (curVal.includes('OTHERS')) {
      $('#formAddDeposit #otherPromotionContainer').show();
    } else {
      $('#formAddDeposit #otherPromotionContainer').hide();
    }
  });

  $('#formAddDeposit').on('submit', function (evt) {
    evt.preventDefault();

    KTApp.block('#modalAddDeposit', {
      opacity: 0.1,
      state: 'primary',
      message: 'Please wait...',
    });

    postDepositValidation
      .validate()
      .then(function (status) {
        if (status != 'Valid') {
          KTApp.unblock('#modalAddDeposit');
          return;
        }

        const curObj = generateDepositObject({
          EVENT: $('#formInfoDetails [name="eventID"]').val(),
          USER: curUSERSN,
          NAME: $('#formAddDeposit [name="depositAddStudent"]').val(),
          COUNSELLOR: $('#formAddDeposit [name="depositAddCounsellor"]').val(),
          UNIVERSITY: $('#formAddDeposit [name="depositAddUniversity"]').val(),
          NOTES: $('#formAddDeposit [name="promotionDetails"]').val(),
          PROMOTION_TYPE: $('#formAddDeposit [name="depositPaymentPromotion"]').val(),
          PROMOTION_DESC: $('#formAddDeposit [name="depositOthPromo"]').val(),
          INTAKE: $('#formAddDeposit [name="depositAddIntake"]').val(),
          AMOUNT: $('#formAddDeposit [name="depositPaymentAmount"]').val(),
          PAYMENT_TYPE: $('#formAddDeposit [name="depositPaymentType"]').val(),
          PAYMENT_DESC: $('#formAddDeposit [name="depositPaymentDesc"]').val(),
          PAYMENT_METHOD: $('#formAddDeposit [name="depositPaymentMethod"]').val(),
        });

        let backendUrl = '';

        if (process.env.MODE === 'PRODUCTION') {
          backendUrl = 'https://backend.icedalnusa.com/';
        } else {
          backendUrl = 'https://icedal-backend.xyz/';
        }

        $.post(
          backendUrl + 'API/generatedInvoices',
          JSON.stringify({
            data: JSON.stringify(curObj),
          })
        )
          .done((fetchRes) => {
            if (fetchRes.code === 200) {
              Swal.fire({
                html: 'Student deposit created!',
                icon: 'success',
                confirmButtonText: 'Close',
                showCancelButton: false,
              });

              studentPromotions.reload();
            } else {
              Swal.fire({
                html: 'cannot create deposit! Please try again later',
                icon: 'warning',
                confirmButtonText: 'Close',
                showCancelButton: false,
              });

              console.log('something went wrong', fetchErr);
            }

            KTapp.unblock('#modalAddDeposit');
          })
          .fail((fetchErr) => {
            Swal.fire({
              html: 'cannot create deposit! Please try again later',
              icon: 'warning',
              confirmButtonText: 'Close',
              showCancelButton: false,
            });

            console.log('something went wrong', fetchErr);
            KTapp.unblock('#modalAddDeposit');
          });
      })
      .catch((err) => {
        KTApp.unblock('#modalAddDeposit');

        Swal.fire({
          html: 'Cannot complete process! Please try again later',
          icon: 'warning',
          confirmButtonText: 'Close',
          showCancelButton: false,
        });

        console.log('something wrong', err);
      });
  });
};

const initPromotion = () => {
  /** Search Student by Event */
  $('[name="depositAddStudent"]').select2({
    ajax: {
      url: BASE_URL + 'Event_Scheduling/getRelatedStudentbyEvent',
      dataType: 'json',
      data: function (params) {
        const query = {
          q: params.term,
          search: params.term,
          page: params.page || 1,
          event: $('#formInfoDetails [name="eventID"]').val(),
        };

        return query;
      },
      delay: 400,
    },
    width: '100%',
    minimumInputLength: 4,
    placeholder: 'Please enter student name',
    allowClear: true,
  });

  /** Search University */
  $('[name="depositAddUniversity"]').select2({
    ajax: {
      url: BASE_URL + 'Event_Scheduling/getRelatedUniversities',
      dataType: 'json',
      data: function (params) {
        const query = {
          q: params.term,
          search: params.term,
          page: params.page || 1,
        };

        return query;
      },
      delay: 400,
    },
    width: '100%',
    minimumInputLength: 4,
    placeholder: 'Please enter university name',
    allowClear: true,
  });

  /** Currency Mask */
  $('[name="depositPaymentAmount"]').inputmask('IDR 999.999.999', {
    numericInput: true,
  });

  $('#modalAddDeposit').on('shown.bs.modal', function () {
    $('#formAddDeposit #otherPaymentDescription').hide();
    $('#formAddDeposit #otherPromotionContainer').hide();
  });
};

export { studentPromotions, studentTableListener, initPromotion, formListener };
